import React from "react";
import { Plus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import NoteSection, { Field } from "@/components/shownotes/NoteSection";
import ExpandField from "@/components/shownotes/ExpandField";
import SceneRuns from "@/components/shownotes/SceneRuns";

// Rehearsal Notes section 2: material rehearsed, scene run times + any number of break times.
export default function RehearsalSection({ fields, set, sceneNames }) {
  const breaks = fields.breaks || [];
  const setBreak = (i, v) => set({ breaks: breaks.map((b, j) => (j === i ? v : b)) });
  return (
    <NoteSection title="Rehearsal" testId="notes-section-rehearsal">
      <div className="space-y-4">
        <ExpandField label="Material Rehearsed" rows={3} value={fields.material} onChange={(v) => set({ material: v })} testId="notes-material-input" />
        <SceneRuns scenes={fields.scenes || []} timer={fields.timer} names={sceneNames} set={set} />
        <Field label="Breaks">
          <div className="flex flex-wrap items-center gap-2" data-testid="notes-breaks">
            {breaks.map((b, i) => (
              <div key={i} className="flex items-center gap-1">
                <Input type="time" className="w-36" value={b} onChange={(e) => setBreak(i, e.target.value)} data-testid={`notes-break-input-${i}`} />
                <Button type="button" size="icon" variant="ghost" className="h-8 w-8 text-slate-400 hover:text-red-600"
                  onClick={() => set({ breaks: breaks.filter((_, j) => j !== i) })} data-testid={`notes-break-remove-${i}`}><X className="h-4 w-4" /></Button>
              </div>
            ))}
            <Button type="button" size="sm" variant="outline" className="rounded-full" onClick={() => set({ breaks: [...breaks, ""] })} data-testid="notes-add-break-btn">
              <Plus className="mr-1 h-3.5 w-3.5" /> Add break
            </Button>
          </div>
        </Field>
      </div>
    </NoteSection>
  );
}
